export const USER_CHANGED_EVENT = 'giotto:user-changed';
